<template>
  <div style="height: 100%;">
    <!-- <div class="header">
      <h1>{{ chartTitle }}</h1>
      <p>{{ chartSubtitle }}</p>
    </div> -->
    <div class="data-info">
      <div class="data-summary">
        <div class="summary-header">
          <h3>用量统计</h3>
          <div class="time-switch inline">
            <button 
              class="switch-btn" 
              :class="{ active: timeType === 'month' }"
              @click="switchTimeType('month')">
              按月
            </button>
            <button 
              class="switch-btn" 
              :class="{ active: timeType === 'day' }"
              @click="switchTimeType('day')">
              按日
            </button>
          </div>
          <div class="date-filter">
            <el-date-picker
              v-if="timeType === 'month'"
              v-model="selectedYear"
              type="year"
              format="yyyy 年"
              value-format="yyyy"
              placeholder="选择年份"
              size="mini"
              @change="handleDateChange"
            />
            <el-date-picker
              v-else
              v-model="selectedMonth"
              type="month"
              format="yyyy 年 MM 月"
              value-format="yyyy-MM"
              placeholder="选择月份"
              size="mini"
              @change="handleDateChange"
            />
          </div>
        </div>
        <!-- <p>{{ totalWaterLabel }}: <span class="highlight">{{ newUserTotal }} 万元</span></p> -->
      </div>
    </div>
    <div class="chart-container">
      <div class="chart-wrapper">
        <div ref="chart" style="width: 100%; height: 100%;"></div>
      </div>
    </div>
  </div>
</template>

<script>
// 注意：在Vue项目中需要先安装echarts: npm install echarts
import * as echarts from 'echarts'
import { rightBoot1 } from '@/api/ksharge'

export default {
  name: 'RechargeChart',
  data() {
    return {
      myChart: null,
      xData: [],
      showDataZoom: true,
      timeType: 'month', // 'month' 或 'day'
      dataTypes: [],
      monthlyDates: [], // 保存月份日期信息
      dailyDates: [], // 保存日期信息
      selectedYear: '',
      selectedMonth: '',
      colors: [
        '#19ffe0', '#4169E1', '#ff9d19', '#bf19ff',
        '#5f45ff', '#02cdff', '#f9e264', '#f47a75',
        '#009db2', '#314976'
      ],
      monthData: {},
      dayData: {},
      current_year_total_usage: 0, // 本年度总用水量
      current_month_total_usage: 0 // 本月总用水量
    }
  },
  computed: {
    totalWaterLabel() {
      return this.timeType === 'month' ? '本年度总用水量' : '本月总用水量'
    },
    newUserTotal() {
      // 根据按钮状态使用不同的参数
      if (this.timeType === 'month') {
        // 点击"按月"时，使用 current_year_total_usage
        return (this.current_year_total_usage || 0).toFixed(2)
      } else {
        // 点击"按日"时，使用 current_month_total_usage
        return (this.current_month_total_usage || 0).toFixed(2)
      }
    },
    currentSeries() {
      const data = this.timeType === 'month' ? this.monthData : this.dayData
      const barWidth = this.dataTypes.length > 1 ? 20 : 30
      return this.dataTypes.map((type, index) => ({
        name: type,
        type: 'bar',
        barMaxWidth: barWidth,
        barGap: this.dataTypes.length > 1 ? '20%' : '30%',
        barCategoryGap: '20%',
        itemStyle: {
          normal: {
            color: this.colors[index % this.colors.length],
            barBorderRadius: [4, 4, 0, 0],
            label: {
              show: true,
              position: "top",
              formatter: function(p) {
                return p.value > 0 ? p.value.toFixed(2) : ''
              },
              textStyle: {
                fontSize: 10,
                color: '#fff'
              }
            }
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 191, 183, 0.5)'
            }
          }
        },
        data: data[type] || []
      }))
    },
    chartOption() {
      return {
        backgroundColor: "transparent",
        title: {
          text: this.chartTitle,
          subtext: this.chartSubtitle,
          x: "4%",
          textStyle: {
            color: '#fff',
            fontSize: 22
          },
          subtextStyle: {
            color: '#90979c',
            fontSize: 16,
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            textStyle: {
              color: "#fff"
            }
          }
        },
        grid: {
          borderWidth: 0,
          top: 80,
          left: '18%',
          bottom: this.showDataZoom ? 65 : 40,
          textStyle: {
            color: "#fff"
          }
        },
        legend: {
          x: '4%',
          top: '8%',
          textStyle: {
            color: '#90979c',
            fontSize: 12
          },
          itemWidth: 12,
          itemHeight: 8,
          data: this.dataTypes
        },
        calculable: true,
        xAxis: [{
          type: "category",
          axisLine: {
            lineStyle: {
              color: '#90979c'
            }
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitArea: {
            show: false
          },
          axisLabel: {
            interval: 0,
            rotate: this.timeType === 'day' ? 45 : 0,
            fontSize: 11
          },
          data: this.xData,
        }],
        yAxis: [{
          type: "value",
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#90979c'
            }
          },
          axisLabel: {
            formatter: '{value} 方'
          },
          axisTick: {
            show: false
          },
          splitArea: {
            show: false
          }
        }],
        dataZoom: this.showDataZoom ? [{
          show: true,
          height: 16,
          xAxisIndex: [0],
          bottom: 18,
          start: 10,
          end: 80,
          handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
          handleSize: '80%',
          handleStyle: {
            color: "#d3dee5",
          },
          textStyle: {
            color: "#fff"
          },
          borderColor: "#90979c"
        }, {
          type: "inside",
          show: true,
          height: 8,
          start: 1,
          end: 35
        }] : [],
        series: this.currentSeries
      }
    }
  },
  mounted() {
    // 初始化年份、月份
    const now = new Date()
    this.selectedYear = now.getFullYear().toString()
    const month = now.getMonth() + 1
    this.selectedMonth = `${this.selectedYear}-${month.toString().padStart(2, '0')}`
    this.generateXData()
    this.initChart()
    window.addEventListener('resize', this.handleResize)
    // 调用接口获取数据
    this.fetchData()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.myChart) {
      this.myChart.dispose()
    }
  },
  methods: {
    // 获取接口数据
    async fetchData() {
      try {
        const token = this.$store.state.print?.goodsForeNo?.token || sessionStorage.getItem('token')
        if (!token) {
          console.warn('缺少 token，无法获取数据')
          return
        }
        
        // 根据 timeType 组装参数（按月：传 year；按日：传 month，对应月份与年份，不受年份选择影响）
        let params = {
          token: token,
          time_range: this.timeType === 'month' ? 'year' : 'month'
        }

        if (this.timeType === 'month') {
          // 按月视图：仅传选中的年份
          params.year = parseInt(this.selectedYear || new Date().getFullYear())
          // month 可以不传，或传当前月占位（根据接口需要，这里不传）
        } else {
          // 按日视图：从选中的月份解析 year 与 month
          const monthStr = this.selectedMonth || ''
          const parts = monthStr.split('-')
          const parsedYear = parts[0] ? parseInt(parts[0]) : new Date().getFullYear()
          const parsedMonth = parts[1] ? parseInt(parts[1]) : (new Date().getMonth() + 1)
          params.year = parsedYear
          params.month = parsedMonth
        }
        
        console.log('请求参数:', params)
        const res = await rightBoot1(params)
        console.log('接口响应:', res)
        
        // 处理响应数据
        if (res && res.data) {
          let responseData = null
          if (res.data.status === 'success' && res.data.data) {
            responseData = res.data.data
          } else if (res.data.data) {
            responseData = res.data.data
          } else {
            responseData = res.data
          }
          
          console.log('处理后的数据:', responseData)
          
          if (responseData) {
            // 处理数据
            this.processResponseData(responseData, params.time_range)
            
            // 更新图表
            this.$nextTick(() => {
              if (this.myChart) {
                this.myChart.setOption(this.chartOption)
              }
            })
          }
        }
      } catch (error) {
        console.error('获取数据失败:', error)
      }
    },
    // 处理接口返回的数据
    processResponseData(data, time_range) {
      // 获取总用水量（如果接口返回了这些字段）
      if (data.current_year_total_usage !== undefined) {
        this.current_year_total_usage = parseFloat(data.current_year_total_usage) || 0
      }
      if (data.current_month_total_usage !== undefined) {
        this.current_month_total_usage = parseFloat(data.current_month_total_usage) || 0
      }
      
      // 处理按月或按日数据
      if (time_range === 'year') {
        // 按月数据 - 使用 monthly_usage
        this.processMonthlyData(data.monthly_usage || [])
      } else {
        // 按日数据 - 使用 daily_usage
        this.processDailyData(data.daily_usage || [])
      }
      
      // 重新生成X轴数据
      this.generateXData()
    },
    handleDateChange() {
      this.fetchData()
    },
    // 处理按月数据
    processMonthlyData(monthlyUsage) {
      if (!Array.isArray(monthlyUsage) || monthlyUsage.length === 0) {
        // 如果没有数据，初始化为空
        this.dataTypes = ['用水量']
        this.monthData = { '用水量': new Array(12).fill(0) }
        this.monthlyDates = []
        for (let i = 1; i <= 12; i++) {
          this.monthlyDates.push(i + '月')
        }
        return
      }
      
      // 找出所有出现过的用水类型，并找出类型最多的那个日期
      let maxTypes = []
      let maxTypeCount = 0
      
      monthlyUsage.forEach(item => {
        if (item.by_type && Array.isArray(item.by_type)) {
          const typeNames = item.by_type.map(t => t.water_type_name)
          if (typeNames.length > maxTypeCount) {
            maxTypeCount = typeNames.length
            maxTypes = typeNames
          }
        }
      })
      
      // 如果找到了类型，使用这些类型；否则使用所有出现过的类型
      if (maxTypes.length === 0) {
        const allTypes = new Set()
        monthlyUsage.forEach(item => {
          if (item.by_type && Array.isArray(item.by_type)) {
            item.by_type.forEach(t => {
              if (t.water_type_name) {
                allTypes.add(t.water_type_name)
              }
            })
          }
        })
        maxTypes = Array.from(allTypes)
      }
      
      // 设置数据类型
      this.dataTypes = maxTypes.length > 0 ? maxTypes : ['用水量']
      
      // 保存月份日期信息
      this.monthlyDates = []
      monthlyUsage.forEach(item => {
        if (item.date) {
          // 从日期中提取月份（例如：2025-10-01 -> 10月）
          const dateMatch = item.date.match(/\d{4}-(\d{2})/)
          if (dateMatch) {
            const month = parseInt(dateMatch[1])
            this.monthlyDates.push(month + '月')
          } else {
            // 如果没有日期，使用索引
            this.monthlyDates.push((this.monthlyDates.length + 1) + '月')
          }
        } else {
          this.monthlyDates.push((this.monthlyDates.length + 1) + '月')
        }
      })
      
      // 如果日期数量不足12个，补充到12个
      while (this.monthlyDates.length < 12) {
        this.monthlyDates.push((this.monthlyDates.length + 1) + '月')
      }
      
      // 初始化月份数据
      this.monthData = {}
      this.dataTypes.forEach(type => {
        this.monthData[type] = new Array(this.monthlyDates.length).fill(0)
      })
      
      // 填充数据
      monthlyUsage.forEach((item, index) => {
        if (item.by_type && Array.isArray(item.by_type)) {
          item.by_type.forEach(typeItem => {
            const typeName = typeItem.water_type_name
            if (this.dataTypes.includes(typeName) && index < this.monthData[typeName].length) {
              this.monthData[typeName][index] = parseFloat(typeItem.usage) || 0
            }
          })
        }
      })
    },
    // 处理按日数据
    processDailyData(dailyUsage) {
      if (!Array.isArray(dailyUsage) || dailyUsage.length === 0) {
        // 如果没有数据，初始化为空
        const now = new Date()
        const daysInMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate()
        this.dataTypes = ['用水量']
        this.dayData = { '用水量': new Array(daysInMonth).fill(0) }
        this.dailyDates = []
        for (let i = 1; i <= daysInMonth; i++) {
          this.dailyDates.push(i + '日')
        }
        return
      }
      
      // 找出所有出现过的用水类型，并找出类型最多的那个日期
      let maxTypes = []
      let maxTypeCount = 0
      
      dailyUsage.forEach(item => {
        if (item.by_type && Array.isArray(item.by_type)) {
          const typeNames = item.by_type.map(t => t.water_type_name)
          if (typeNames.length > maxTypeCount) {
            maxTypeCount = typeNames.length
            maxTypes = typeNames
          }
        }
      })
      
      // 如果找到了类型，使用这些类型；否则使用所有出现过的类型
      if (maxTypes.length === 0) {
        const allTypes = new Set()
        dailyUsage.forEach(item => {
          if (item.by_type && Array.isArray(item.by_type)) {
            item.by_type.forEach(t => {
              if (t.water_type_name) {
                allTypes.add(t.water_type_name)
              }
            })
          }
        })
        maxTypes = Array.from(allTypes)
      }
      
      // 设置数据类型
      this.dataTypes = maxTypes.length > 0 ? maxTypes : ['用水量']
      
      // 保存日期信息并排序
      this.dailyDates = []
      const dateMap = new Map() // 用于存储日期字符串和索引的映射
      
      // 先收集所有日期并排序
      const sortedDates = dailyUsage
        .filter(item => item.date)
        .map(item => item.date)
        .sort()
        .filter((date, index, arr) => arr.indexOf(date) === index) // 去重
      
      // 生成日期标签和映射
      sortedDates.forEach(date => {
        const dateMatch = date.match(/\d{4}-\d{2}-(\d{2})/)
        if (dateMatch) {
          const day = parseInt(dateMatch[1])
          const dayLabel = day + '日'
          dateMap.set(date, this.dailyDates.length)
          this.dailyDates.push(dayLabel)
        }
      })
      
      // 如果没有日期信息，根据数组长度生成
      if (this.dailyDates.length === 0) {
        const now = new Date()
        const daysInMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate()
        for (let i = 1; i <= daysInMonth; i++) {
          this.dailyDates.push(i + '日')
        }
      }
      
      // 初始化日期数据
      this.dayData = {}
      this.dataTypes.forEach(type => {
        this.dayData[type] = new Array(this.dailyDates.length).fill(0)
      })
      
      // 填充数据
      dailyUsage.forEach(item => {
        if (item.date && item.by_type && Array.isArray(item.by_type)) {
          const dayIndex = dateMap.get(item.date)
          if (dayIndex !== undefined && dayIndex < this.dayData[this.dataTypes[0]].length) {
            item.by_type.forEach(typeItem => {
              const typeName = typeItem.water_type_name
              if (this.dataTypes.includes(typeName)) {
                this.dayData[typeName][dayIndex] = parseFloat(typeItem.usage) || 0
              }
            })
          }
        }
      })
    },
    generateXData() {
      if (this.timeType === 'month') {
        // 使用保存的月份日期信息
        this.xData = this.monthlyDates.length > 0 ? this.monthlyDates : []
        // 如果为空，生成默认的12个月
        if (this.xData.length === 0) {
          for (let i = 1; i <= 12; i++) {
            this.xData.push(i + '月')
          }
        }
      } else {
        // 使用保存的日期信息
        this.xData = this.dailyDates.length > 0 ? this.dailyDates : []
        // 如果为空，生成本月的所有日期
        if (this.xData.length === 0) {
          const now = new Date()
          const daysInMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate()
          for (let i = 1; i <= daysInMonth; i++) {
            this.xData.push(i + '日')
          }
        }
      }
    },
    switchTimeType(type) {
      this.timeType = type
      // 切换时重新获取数据
      this.fetchData()
    },
    initChart() {
      this.myChart = echarts.init(this.$refs.chart)
      this.myChart.setOption(this.chartOption)
      
      // 添加事件监听
      this.addEventListeners()
    },
    handleResize() {
      if (this.myChart) {
        this.myChart.resize()
      }
    },
    addEventListeners() {
      // 添加点击事件
      this.myChart.on('click', (params) => {
        this.$emit('chart-click', params)
        console.log('点击了:', params.seriesName, params.name, params.value)
      })
    },
  }
}
</script>

<style lang="less" scoped>
.header {
  text-align: center;
  margin-bottom: 40px;
  padding: 20px;
  
  h1 {
    font-size: 32px;
    margin-bottom: 10px;
    color: #fff;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  }
  
  p {
    color: #90979c;
    font-size: 16px;
    max-width: 600px;
    margin: 0 auto;
    line-height: 1.6;
  }
}

.chart-container {
  display: flex;
  justify-content: center;
  height: 80%;
}

.chart-wrapper {
  width: 100%;
  max-width: 1200px;
  height: 95%;
  background: rgba(16, 33, 77, 0.3);
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 20, 80, 0.4);
  border: 1px solid rgba(100, 150, 255, 0.2);
}

.controls {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 30px;
}

.control-btn {
  background: rgba(30, 60, 120, 0.7);
  border: 1px solid rgba(100, 150, 255, 0.3);
  color: #b3ccf8;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  
  &:hover {
    background: rgba(50, 100, 200, 0.7);
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 50, 150, 0.3);
  }
}

.data-info {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 30px;
  // margin-top: 30px;
}

.data-summary, .monthly-stats {
  background: rgba(20, 40, 80, 0.5);
  padding: 0px 20px;
  border-radius: 8px;
  flex: 1;
  min-width: 300px;
  border: 1px solid rgba(100, 150, 255, 0.2);
}

.data-summary h3, .monthly-stats h3 {
  margin-top: 7px;
  margin-bottom: 7px;
  color: #b3ccf8;
  font-size: 18px;
  border-bottom: 1px solid rgba(100, 150, 255, 0.3);
  padding-bottom: 10px;
}

.data-summary p {
  margin-bottom: 10px;
  font-size: 16px;
}

.highlight {
  color: #f9e264;
  font-weight: bold;
}
.time-switch {
display: flex;
justify-content: center;
gap: 10px;
margin: 15px 0;
}
.time-switch.inline {
justify-content: flex-start;
margin: 0;
}
.summary-header {
margin: 20px 0;
display: flex;
align-items: center;
justify-content: space-between;
gap: 16px;
flex-wrap: wrap;
}
.summary-header h3 {
margin: 0;
}
.date-filter {
  display: flex;
  align-items: center;
  
  /deep/ .el-date-editor {
    .el-input__inner {
      background-color: rgba(30, 60, 120, 0.5);
      border: 1px solid rgba(100, 150, 255, 0.3);
      color: #b3ccf8;
      
      &::placeholder {
        color: #8ca0d7;
      }
    }
    
    &:hover .el-input__inner {
      border-color: rgba(100, 150, 255, 0.5);
    }
  }
}
.switch-btn {
background: rgba(30, 60, 120, 0.5);
border: 1px solid rgba(100, 150, 255, 0.3);
color: #b3ccf8;
padding: 8px 24px;
border-radius: 6px;
cursor: pointer;
transition: all 0.3s ease;
font-size: 14px;
font-weight: normal;

&:hover {
  background: rgba(50, 100, 200, 0.7);
  border-color: rgba(100, 150, 255, 0.5);
}

&.active {
  background: rgba(25, 255, 224, 0.3);
  border-color: rgba(25, 255, 224, 0.6);
  color: #19ffe0;
  font-weight: bold;
  box-shadow: 0 0 10px rgba(25, 255, 224, 0.3);
}
}

.month-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid rgba(100, 150, 255, 0.1);
  
  &:last-child {
    border-bottom: none;
  }
}

.month-name {
  font-size: 14px;
  color: #b3ccf8;
}

.month-value {
  color: #f9e264;
  font-weight: bold;
}

@media (max-width: 768px) {
  .chart-wrapper {
    height: 500px;
    padding: 15px;
  }
  
  .header h1 {
    font-size: 26px;
  }
  
  .data-info {
    flex-direction: column;
  }
  
  .controls {
    flex-direction: column;
    align-items: center;
  }
  
  .control-btn {
    width: 80%;
  }
}
</style>